import { create } from 'zustand';

export const useRenderStats = create<{ calls: number; triangles: number }>(() => ({
  calls: 0,
  triangles: 0,
}));
